import React from 'react';
import { Col, Row, Button } from 'reactstrap';
import Arrow from '../../components/chrome/elements/icons/volunteering/arrow';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const MatchingProcess = () => (
	<Col sm="12" xs="12" md="12" lg="12" style={{ overflow: 'hidden', paddingTop: '2rem' }} >
		<p className="text-center matching-heading">Become a part of the life of the person you support and see the impact of your giving  </p>
		<Row className="text-center guide-row d-flex justify-content-center">
			<Col xs="12" sm="12" md="4" lg="3" >
				<img className="matching-process-image" src={`${config.cdnUrl}/static/images/meet-your-match/meet-the-one-donate.svg`} alt="Donate" />
				<p className="matching-process-heading cool-link"><span className="matching-process-head">1. Give</span></p>
				<p>Choose a program in the list from a host of causes to give monthly</p>
			</Col>
			<Col xs="3" sm="3" md="4" lg="1" className="d-flex justify-content-center " >
				<Arrow className="guide-arrow " size="50%" />
			</Col>
			<Col xs="12" sm="12" md="4" lg="3">
				<img className="matching-process-image" src={`${config.cdnUrl}/static/images/meet-your-match/meet-the-one-ben-assignment.svg`} alt="ben-assignment" />
				<p className="matching-process-heading cool-link "><span className="matching-process-head">2. Meet your one</span></p>
				<p>Receive details of the person you will support. </p>
			</Col>
			<Col xs="3" sm="3" md="4" lg="1" className="d-flex justify-content-center  " >
				<Arrow className="guide-arrow " size="50%" />
			</Col>
			<Col xs="12" sm="12" md="4" lg="3">
				<img className="matching-process-image" src={`${config.cdnUrl}/static/images/meet-your-match/meet-the-one-ben-report.svg`} alt="ben-report" />
				<p className="matching-process-heading cool-link"><span className="matching-process-head">3. Learn more about them</span></p>
				<p>Get annual updates about the person you will support</p>
			</Col>
		</Row>

		<div style={{ paddingTop: '2rem' }}>
			<center><a href="/search?tag=Individual%20Support&type=relevance" ><Button color="primary" className=" btn matching-button " type="submit" >  Meet The One </Button></a></center>
		</div>

		<style global jsx>
			{
				`





.arrow-matching{
	padding-top: 28px;
}



				.matching-process-head{
          color: #444444;
        }
        .matching-process-image{
          height: 90px;
        }
        .matching-process-heading{
          padding-top: 1.5rem;
        }
        .matching-arrow{
          height: 20px;
        }
        .cool-link {

        display: block;
        color: #008c8c;
        text-decoration: none;
    }

    .cool-link::after {
        content: '';
        display: block;
        width: 0;
        height: 2px;
        background: #008c8c;
        transition: width .3s;
    }

    .cool-link:hover::after {
        width: 100%;
        //transition: width .3s;
    }

        `
			}
		</style>
	</Col>
);

export default MatchingProcess;
